import { render, staticRenderFns } from "./eventDetails.vue?vue&type=template&id=33db26b3&scoped=true"
import script from "./eventDetails.vue?vue&type=script&lang=js"
export * from "./eventDetails.vue?vue&type=script&lang=js"
import style0 from "./eventDetails.vue?vue&type=style&index=0&id=33db26b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db26b3",
  null
  
)

export default component.exports